import $notification from './notification.js';

export default [$notification];
